import About from "./components/About";
import Designs from "./components/Designs";
import Navbar from "./components/Navbar";
import Taglinedomain from "./components/Taglinedomain";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Recentwork from "./components/Recentwork";
import Footer from "./components/Footer";
// import Contact from "./components/Contact";
import Contactemail from "./components/Contactemail";
import ScrollToTop from "./components/ScrollToTop";
import PageLoader from "./components/PageLoader";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <PageLoader />
      <Navbar />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Taglinedomain />
              <Recentwork />
            </>
          }
        />
        <Route path="/about" element={<About />} />
        <Route path="/designs" element={<Designs />} />
        <Route path="/contact" element={<Contactemail />} />
        <Route path="/projects" element={<Recentwork />} />
        <Route
          path="*"
          element={
            <>
              <Contactemail />
            </>
          }
        />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
